const Host =
	process.env.NODE_ENV === "production"
		? "https://api.cyougame.kr"
		: process.env.NODE_ENV === "test"
		? "https://api.cyougame.ga"
		: "http://localhost:3005";
export default Host;
